export default __webpack_public_path__ + "static/media/DGAutoLtd-4.0bfa9031.jpg";